import { mapActions } from 'vuex'
import { isUrl } from 'bits/url'
import { trackEvent } from 'bits/analytics'

export default {
  data() {
    return {
      pasteToPostSubscribed: false,
      $_pasteToPostMixin_callback: null,
    }
  },
  methods: {
    ...mapActions('post', ['createPost']),
    $_pasteToPostMixin_processPaste(e) {
      // Sometimes, we don't get e.target, especially in Firefox.
      // In that case, ignore.
      if (!e.target && !e.target.tagName) {
        return
      }
      // Sometimes we don't get clipboard data, especially in Safari.
      // In that case, ignore.
      if (!e.clipboardData || !e.clipboardData.items) {
        return
      }
      // Ignore if event is on an input field
      if (this.$_pasteToPostMixin_isEventOnAnInputField(e)) {
        return
      }

      // for of throws errors, hence the old-school loop
      for (let i = 0; i < e.clipboardData.items.length; i++) {
        const clipboardItem = e.clipboardData.items[i]
        const itemType = clipboardItem.type
        if (itemType.indexOf('image') >= 0) {
          const file = clipboardItem.getAsFile()
          if (file) {
            this.$_pasteToPostMixin_processFilePaste(file)
          }
        } else if (itemType === 'text/plain') {
          const text = e.clipboardData.getData('text')
          if (text) {
            this.$_pasteToPostMixin_processTextPaste(text)
          }
        }
      }
    },

    $_pasteToPostMixin_isEventOnAnInputField(e) {
      // Sometimes, target of pasting will be onto arbitrary #text target
      // In that case, we get originalTarget, or even explicitOriginalTarget
      let targetTag = e.target.tagName
        ? e.target.tagName.toUpperCase()
        : e.originalTarget.tagName
        ? e.originalTarget.tagName.toUpperCase()
        : e.explicitOriginalTarget.tagName && e.explicitOriginalTarget.tagName.toUpperCase()
      // The last check is true for Trix because it keeps a copy of the editor in some sort of dom outside the current dom.
      if (
        targetTag == 'TEXTAREA' ||
        targetTag == 'INPUT' ||
        targetTag == 'TRIX-EDITOR' ||
        !document.documentElement.contains(e.target)
      )
        return true
      else if (e.target.contentEditable === 'true' || e.target.contentEditable === true) return true
      else {
        const trixCollection = document.getElementsByTagName('trix-editor')
        for (let i = 0; i < trixCollection.length; i++) {
          const trixElement = trixCollection[i]
          if (trixElement.contains(e.target)) return true
        }
        return false
      }
    },

    $_pasteToPostMixin_processFilePaste(file) {
      this.$_pasteToPostMixin_track('File')
      const newPost = {
        attributes: {
          file: file,
        },
      }
      this.createPost(newPost)
      this.$_pasteToPostMixin_callback && this.$_pasteToPostMixin_callback(newPost)
    },

    $_pasteToPostMixin_processTextPaste(text) {
      let newPost = {}
      if (isUrl(text)) {
        this.$_pasteToPostMixin_track('Link')
        newPost = {
          attributes: {
            attachment: text,
          },
        }
      } else {
        this.$_pasteToPostMixin_track('Text')
        newPost = {
          attributes: {
            body: text,
          },
        }
      }
      this.createPost(newPost)
      this.$_pasteToPostMixin_callback && this.$_pasteToPostMixin_callback(newPost)
    },

    $_pasteToPostMixin_track(type) {
      trackEvent('Posts', 'add', `Paste ${type}`)
    },

    enablePasteToPost(callback) {
      if (this.pasteToPostSubscribed) return
      this.$_pasteToPostMixin_callback = callback
      window.addEventListener('paste', this.$_pasteToPostMixin_processPaste)
      this.pasteToPostSubscribed = true
    },

    disablePasteToPost() {
      if (!this.pasteToPostSubscribed) return
      this.$_pasteToPostMixin_callback = null
      window.removeEventListener('paste', this.$_pasteToPostMixin_processPaste)
      this.pasteToPostSubscribed = false
    },
  },
}
